import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"container-view"},[_c(VFadeTransition,[(_vm.isShow)?_c(VContainer,{staticClass:"pb-12"},[_c('Header'),_vm._v(" "),_c('Career'),_vm._v(" "),_c('Skill'),_vm._v(" "),_c('Footer')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }